export default __webpack_public_path__ + "static/media/slot-banners.cebab254.webp";